import { DateTime } from 'luxon';
import React from 'react';
import { Card } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useAuth } from '../../auth';
import { formatCurrency } from '../../../core/_util';
import { NoDataPage } from '../../resources/components/NoDataPage';

const CaptableManagementRound = ({
  title,
  securityClasses,
}: {
  title: string;
  securityClasses: any;
}) => {
  const { formatMessage } = useIntl();

  return (
    <Card className="w-100 p-4 bg-white">
      <div>
        <p className="text-muted">{formatMessage({ id: title })}</p>
      </div>
      {/* Add Bootstrap classes for scrolling */}
      {securityClasses && securityClasses.length > 0 ?
        securityClasses.map((securityClass: any, index: any) => (
          <div className="overflow-auto" style={{ maxHeight: '315px' }}>
            <CaptableManagementRoundItem key={index} securityClass={securityClass} />
          </div>
        ))
        :
        <div className='d-flex align-items-center justify-content-center h-100'>
          <NoDataPage />
        </div>
      }
    </Card>
  );
};

const CaptableManagementRoundItem = ({ securityClass }: { securityClass: any }) => {
  const { companyCurrency } = useAuth();

  function calculateTotalShares(shareTransactions: { numberOfShares: number }[]): number {
    return shareTransactions.reduce((total: number, transaction) => {
      return total + transaction.numberOfShares;
    }, 0);
  }

  const { formatMessage } = useIntl();
  return (
    <>
      <div className="bg-light px-4 py-3 mb-2 rounded">
        <div className="d-flex justify-content-between align-items-center">
          <div className="px-2" style={{ borderLeft: '3px solid blue', width: '200px' }}>
            <h5 className="m-0 fw-semibold text-wrap">{securityClass?.securityClass?.className}</h5>
            {/* <h5 className="m-0 fw-semibold text-wrap">{securityClass?.securityClass?.className}</h5> */}
            <p className="m-0 text-muted">
              {DateTime.fromISO(securityClass?.securityClass?.createdAt).toFormat('dd/MM/yyyy')}
            </p>
          </div>
          <div className='flex-fill'>
            <h5 className="m-0 fw-semibold">{`${companyCurrency} ${formatCurrency(securityClass?.pricePerShare)}`}</h5>
            <p className="m-0 text-muted">{formatMessage({ id: 'Price Per Share' })}</p>
          </div>
          <div className='flex-fill'>
            <h5 className="m-0 fw-semibold">{securityClass?.securityClass?.classCode}</h5>
            <p className="m-0 text-muted">{formatMessage({ id: 'Class Code' })}</p>
          </div>
          <div className='flex-fill'>
            <h5 className="m-0 fw-semibold text-end">{calculateTotalShares(securityClass?.shareTransactions)}</h5>
            <p className="m-0 text-muted text-end">{formatMessage({ id: 'Shares' })}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaptableManagementRound;
